import { createEndpoint } from "../createEndpoint";
import type { HttpClient } from "../httpClient";
import {
    PublicContactSubmitResponseSchema,
    type PublicContactSubmitRequest,
    type PublicContactSubmitResponse,
} from "../schemas/public-contact";

export function createPublicContactApi(http: HttpClient, baseUrl: string) {
    return {
        submit: createEndpoint<PublicContactSubmitResponse, PublicContactSubmitRequest>(http, "POST", "", {
            base: `${baseUrl}/public/contact`,
            responseSchema: PublicContactSubmitResponseSchema,
        }),
    };
}

export type PublicContactApi = ReturnType<typeof createPublicContactApi>;
